import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { AiFillCloseCircle } from "react-icons/ai";
import Select from "react-select";
import { State, City } from "country-state-city";
import toast from "react-hot-toast";
import uploadImg from "./ReuseableImgUploadFuctions/uploadImg";
import axios from "axios";

function EditProfileModal({ onClose, userData }) {
  const [loading, setLoading] = useState(false);
  const [allStates, setAllStates] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [selectedState, setSelectedState] = useState();
  const [selectedCity, setSelectedCity] = useState();
  const [profilePic, setProfilePic] = useState(userData?.profilePic || "");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue,
  } = useForm();

  console.log("User data: ", userData);
  //Fetching all states of India
  useEffect(() => {
    const states = State.getStatesOfCountry("IN"); //IN is the country code for India
    console.log("States: ", states);
    const formattedStates = states.map((state) => ({
      value: state?.isoCode,
      label: state?.name,
    }));

    setAllStates(formattedStates);
  }, []);

  //Setting existing state to the selectedState initially
  useEffect(() => {
    if (allStates?.length > 0 && userData?.state) {
      const selectedState = allStates?.find(
        (state) => state.label === userData?.state
      );
      setSelectedState(selectedState || null);
    }
  }, [allStates, userData]);

  //Fetch cities when state is selected
  useEffect(() => {
    if (selectedState) {
      console.log("Selected State: ", selectedState);
      const cities = City.getCitiesOfState("IN", selectedState?.value);
      const formattedCities = cities.map((city) => ({
        value: city?.name,
        label: city?.name,
      }));
      setAllCities(formattedCities);
    } else {
      setAllCities([]);
    }
  }, [selectedState]);

  const uploadHandle = async (file) => {
    setIsImageUploading(true);
    toast("Uploading, Please wait...", {
      icon: "👏",
      style: {
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
      duration: 4000,
    });

    const imgUrl = await uploadImg(file[0]);

    setProfilePic(imgUrl);
    setIsImageUploading(false);
  };

  useEffect(() => {
    reset({
      ...userData,
      dateOfBirth: userData?.dateOfBirth.slice(0, 10),
      state: userData?.state || "",
      city: userData?.city || "",
    });
  }, [userData, reset]);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      //Creating final data object with image URL
      const finalData = {
        ...data,
        profilePic: profilePic || userData?.profilePic,
      };

      console.log("Final Data: ", finalData);
      let config = {
        method: "patch",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/users/user-edit-profile/${userData?.id}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: finalData,
      };

      axios
        .request(config)
        .then((response) => {
          console.log("Response of onSubmit: ", response.data);
          toast.success("Staff Updated");
          const updatedUser = {
            ...response.data.user,
            id: response.data.user._id || response.data.user.id,
          };
          delete updatedUser._id; // Remove _id to avoid conflicts

          localStorage.setItem(
            "yostelPG-userData",
            JSON.stringify(updatedUser)
          );
          setLoading(false);
          onClose();
        })
        .catch((error) => {
          console.log("Error in submitting form: ", error);
          toast.error(error.response.data.message);
          setLoading(false);
        });
    } catch (error) {
      console.log("Error in submitting form: ", error);
      alert("Error in submitting form, Please try again");
    }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50  backdrop-blur-sm">
      <div className="relative h-[31rem] md:h-auto max-h-[95%] overflow-y-scroll  bg-white p-8 lg:py-8 lg:px-16 rounded-lg shadow-lg w-full max-w-5xl">
        <div className="mb-6">
          <h2 className="text-2xl font-semibold text-center">Edit Profile</h2>
          <AiFillCloseCircle
            onClick={onClose}
            className="cursor-pointer text-primaryColor absolute top-4 right-4"
            size={30}
          />
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Name  */}
              <div className="flex flex-col">
                <label htmlFor="" className="text-sm font-medium mb-1">
                  Name
                </label>

                <input
                  type="text"
                  {...register("name", { required: "Name is required" })}
                  className={`border rounded-md p-2 focus:outline-none focus:ring ${
                    errors.name ? "border-red-500" : "focus:border-blue-300"
                  }`}
                  placeholder="Enter name"
                />
              </div>

              {/* Mobile No.  */}
              <div className="flex flex-col">
                <label className="text-sm font-medium mb-1">
                  Mob Number <span className="text-red-500">*</span>
                </label>
                <input
                  {...register("phoneNumber", {
                    required: "Mobile Number number is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Mobile number must be 10 digits",
                    },
                  })}
                  type="number"
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 10);
                  }}
                  className={`border rounded-md p-2 focus:outline-none focus:ring ${
                    errors.phoneNumber
                      ? "border-red-500"
                      : "focus:border-blue-300"
                  }`}
                  placeholder="Enter Mobile Number"
                />
                {errors.phoneNumber && (
                  <p className="text-red-500 text-xs">
                    {errors.phoneNumber.message}
                  </p>
                )}
              </div>

              {/* Email ID  */}
              <div className="flex flex-col">
                <label className="text-sm font-medium mb-1">
                  Email ID <span className="text-red-500">*</span>
                </label>
                <input
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Enter a valid email",
                    },
                  })}
                  type="email"
                  className={`border rounded-md p-2 focus:outline-none focus:ring ${
                    errors.email ? "border-red-500" : "focus:border-blue-300"
                  }`}
                  placeholder="Enter email"
                />
                {errors.email && (
                  <p className="text-red-500 text-xs">{errors.email.message}</p>
                )}
              </div>

              {/* Aadhaar Number  */}
              <div className="flex flex-col">
                <label className="text-sm font-medium mb-1">
                  Adhaar Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 12); // Replace non-numeric characters
                  }}
                  {...register("adhaarNumber", {
                    required: "Aadhaar is required",
                  })}
                  className={`border rounded-md p-2 focus:outline-none focus:ring ${
                    errors.adhaarNumber
                      ? "border-red-500"
                      : "focus:border-blue-300"
                  }`}
                  placeholder="Enter your Aadhaar Number"
                />

                {errors.adhaarNumber && (
                  <p className="text-red-500 text-xs">
                    {errors.adhaarNumber.message}
                  </p>
                )}
              </div>

              {/* Date of Birth  */}
              <div className="flex flex-col">
                <label className="text-sm font-medium mb-1">
                  Date of Birth <span className="text-red-500">*</span>
                </label>
                <input
                  {...register("dateOfBirth", {
                    required: "Date of birth is required",
                  })}
                  type="date"
                  className={`border rounded-md p-2 focus:outline-none focus:ring ${
                    errors.dateOfBirth
                      ? "border-red-500"
                      : "focus:border-blue-300"
                  }`}
                />
                {errors.dateOfBirth && (
                  <p className="text-red-500 text-xs">
                    {errors.dateOfBirth.message}
                  </p>
                )}
              </div>

              {/* Gender  */}
              <div className="flex flex-col">
                <label className="text-sm font-medium mb-1">Gender</label>
                <select
                  {...register("gender", { required: "Gender is required" })}
                  className={`border rounded-md p-2 focus:outline-none focus:ring ${
                    errors.gender ? "border-red-500" : "focus:border-blue-300"
                  }`}
                >
                  <option value="">Select Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </select>
                {errors.gender && (
                  <p className="text-red-500 text-xs">
                    {errors.gender.message}
                  </p>
                )}
              </div>

              {/* Nationality */}
              <div className="flex flex-col">
                <label className="text-sm font-medium mb-1">
                  Nationality <span className="text-red-500">*</span>
                </label>
                <input
                  {...register("nationality", {
                    required: "Nationality is required",
                  })}
                  type="text"
                  className={`border rounded-md p-2 focus:outline-none focus:ring ${
                    errors.nationality
                      ? "border-red-500"
                      : "focus:border-blue-300"
                  }`}
                  placeholder="Enter nationality"
                />
                {errors.nationality && (
                  <p className="text-red-500 text-xs">
                    {errors.nationality.message}
                  </p>
                )}
              </div>

              {/* Address */}
              <div className="flex flex-col">
                <label className="text-sm font-medium mb-1">
                  Address <span className="text-red-500">*</span>
                </label>
                <input
                  {...register("address", { required: "Address is required" })}
                  className={`border rounded-md p-2 focus:outline-none focus:ring ${
                    errors.address ? "border-red-500" : "focus:border-blue-300"
                  }`}
                  placeholder="Enter address"
                />
                {errors.address && (
                  <p className="text-red-500 text-xs">
                    {errors.address.message}
                  </p>
                )}
              </div>

              {/* State */}
              <div>
                <label
                  htmlFor="state"
                  className="text-sm font-medium text-primaryTextColor"
                >
                  State *
                </label>
                <Select
                  options={allStates}
                  value={
                    allStates.find((state) => state.label === watch("state")) ||
                    null
                  }
                  onChange={(option) => {
                    console.log("option", option);
                    setSelectedState(option);
                    setValue("state", option.label);
                  }}
                  required
                  placeholder="Select State"
                  className={`border ${
                    errors.state ? "border-red-500" : "border-gray-300"
                  } rounded w-full`}
                />
                {errors.state && (
                  <span className="text-red-500 text-sm">
                    {errors.state.message}
                  </span>
                )}
              </div>

              {/* City  */}
              <div>
                <label
                  htmlFor="city"
                  className="text-sm font-medium text-primaryTextColor"
                >
                  City *
                </label>

                <Select
                  options={allCities}
                  value={
                    allCities.find((city) => city.label === watch("city")) ||
                    null
                  } // Pre-select state in edit mode
                  onChange={(option) => {
                    console.log("option", option);
                    setValue("city", option.label, { shouldValidate: true }); // Ensure validation triggers
                  }}
                  required
                  placeholder="Select City"
                  className={`border ${
                    errors.city ? "border-red-500" : "border-gray-300"
                  } rounded w-full`}
                />
                {errors.city && (
                  <span className="text-red-500 text-sm">
                    {errors.city.message}
                  </span>
                )}
              </div>
              {/* Profile Pic  */}
              <div className="flex flex-col ">
                <label htmlFor="" className="text-sm font-medium mb-1">
                  Profile Pic <span className="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  {...register("profilePic")}
                  onChange={(e) => {
                    uploadHandle(e.target.files);
                  }}
                  className={`border rounded-md p-2 focus:outline-none focus:ring ${
                    errors.profilePic
                      ? "border-red-500"
                      : "focus:border-blue-300"
                  }`}
                />
                {errors.profilePic && (
                  <p className="text-red-500 text-xs">
                    {errors.profilePic.message}
                  </p>
                )}
                <img
                  src={profilePic}
                  alt="No Image"
                  srcset=""
                  className="w-[6rem] rounded-md object-cover mt-2"
                />
              </div>

              {/* Buttons  */}
              <div className="flex justify-between mt-6 gap-6 col-span-2">
                <button
                  onClick={onClose}
                  type="button"
                  className="bg-white w-[50%] border hover:bg-secondaryTextColor px-4 py-2 rounded-md"
                >
                  Cancel
                </button>
                <button
                  disabled={isImageUploading}
                  type="submit"
                  className={`tracking-wide w-[50%]  ${
                    isImageUploading ? "cursor-not-allowed" : "cursor-pointer"
                  } bg-primaryBtnColor text-white py-2 px-4 rounded-lg hover:bg-primaryBtnHoverColor`}
                >
                  {"Save"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EditProfileModal;
